export default{
    SET_BRAND_GUIDELINE_DETAILS(state, payload){
        state[payload.key] = payload.value;
    },
    GET_CARD_OPTIONS(state,value){
        state.cardoptions=value
    },
    GET_SELECTED_CARD(state,value){
        state.selectedcard=value
    },
    CREATE_ORDER(state,value){
        state.createorder=value
    },
    ITEMS_TOTAL(state, value) {
        state.itemstotal=value
    },
    GET_REQUEST(state, value) {
        state.getrequest=value
    },
    SELECTED_REQUEST(state, value) {
        state.selectedreq=value
    },
    PREVIOUS_ROUTE(state, value) {
        state.previousRoute=value
    },
    GET_COMMENTS(state, value) {
        state.getcomments=value
    },
    ADD_COMMENTS(state,value){
        state.addcomments=value
    },
    GET_COUPONS(state,value){
        state.getcoupons=value
    },
    
    
}